var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAu33(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 156,
    viewBox: "0 0 448 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.588 -37.9262C214.914 -37.6543 217.063 -39.082 218.033 -42.2091C231.963 -88.6054 252.235 -129.903 290.699 -160.443C319.322 -183.216 350.318 -190.15 383.688 -181.245C431.976 -168.397 452.143 -123.785 447.257 -78.1024C444.589 -52.7799 437.711 -20.2516 426.622 19.4826C413.073 68.1562 392.819 130.29 365.859 205.883C359.518 223.626 351.565 241.097 342.001 258.296C256.757 411.658 62.3578 155.154 19.5277 90.9635C-11.1915 44.9242 -4.6942 -14.5753 32.5743 -55.0573C61.3703 -86.362 108.255 -80.7536 143.236 -63.9286C162.78 -54.4964 190.484 -39.7107 211.588 -37.9262Z",
    fill: "#4B2C5E",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAu33);
export default __webpack_public_path__ + "static/media/au3(3).302a07b6157d70d794f9ca60feb1ca17.svg";
export { ForwardRef as ReactComponent };